const InvoiceStatus = {
    Open : "Open",
    ToBeInvoiced : "ToBeInvoiced",
    Invoiced : "Invoiced",
    NotToBeInvoiced : "NotToBeInvoiced",
    Flagged:"Flagged"
}

export {InvoiceStatus}